import React from 'react';
import FileWithProgress from 'components/FileUpload/types/fileWithProgress';
import { UploadedFileList, UploadedFileListWrap } from './style';
import UploadedFileListItem from './UploadedFileListItem';

interface PropsType {
	links: FileWithProgress[];
	handleDelete?: (file: string) => void;
}

function UploadedFiles({ links, handleDelete }: PropsType) {
	return (links && links.length > 0) ? (
		<UploadedFileListWrap>
			<UploadedFileList>
				{links.map((link, index) => (
					<UploadedFileListItem
						link={link}
						key={index}
						handleDelete={handleDelete}
					/>
				))}
			</UploadedFileList>
		</UploadedFileListWrap>
	) : null;
}

export default UploadedFiles;
